{
  "企业认证审核": "Enterprise certification review",
  "企业身份认证审核": "Enterprise identity review",
  "申请类型": "Application type",
  "审核状态": "Review status",
  "企业登记材料": "Company registration evidence",
  "提交说明": "Submission note",
  "提交时间": "Submitted at",
  "处理时间": "Processed at",
  "处理人": "Processed by",
  "处理说明": "Processing note",
  "待审核": "Pending review",
  "已退回": "Returned",
  "已失效": "Cancelled",
  "企业已停用": "Enterprise disabled",
  "企业名称或登记号": "Enterprise name or registration number",
  "退回": "Return",
  "认证申请": "Certification applications",
  "认证申请详情": "Certification application",
  "通过企业认证": "Approve certification",
  "退回企业认证": "Return certification",
  "申请编号": "Application ID",
  "提交人": "Submitted by",
  "提交时企业资料": "Enterprise details at submission",
  "历史申请缺少主体快照，请退回后重新提交。": "This historical application has no company snapshot. Return it for resubmission.",
  "退回原因": "Reason for return",
  "请填写退回原因": "Enter a reason for return",
  "申请已处理、企业已停用或资料不完整，请核对后重新加载。": "The application was processed, the enterprise is disabled, or details are incomplete. Review and reload.",
  "买方与供应方分别审核，认证通过不自动开通会员。": "Buyer and supplier certifications are reviewed separately. Approval does not activate membership.",
  "PDF 无法读取，请下载原文件核对": "Unable to read this PDF. Download the original to check it.",
  "通过_certification": "Approve",
  "认证材料加载失败，请重试": "Unable to load the document. Please retry.",
  "认证材料格式不受支持": "Unsupported document format",
  "采购商": "Purchaser",
  "进口商": "Importer",
  "经销商": "Distributor",
  "贸易采购代理": "Procurement agent",
  "其他采购主体": "Other buyer",
  "生产商": "Manufacturer",
  "贸易商": "Trading company",
  "品牌商": "Brand owner",
  "供应链服务商": "Supply chain service provider",
  "其他供应主体": "Other supplier",
  "有自有进口资质": "Own import qualifications",
  "委托有资质代理": "Qualified import agent",
  "不涉及跨境进口": "No cross-border imports",
  "待完善": "To be completed",
  "可自行办理出口": "Direct export capability",
  "通过授权出口代理": "Authorized export agent",
  "仅供应国内": "Domestic supply only",
  "境外注册主体采用其他登记方式": "Alternative overseas registration",
  "因商业隐私或数据安全暂不上传": "Commercial privacy or data security",
  "暂时无法提供证照": "Document temporarily unavailable",
  "其他原因": "Other reason",
  "采购业务资料": "Procurement profile",
  "供应业务资料": "Supply profile",
  "采购业务身份": "Procurement role",
  "销售业务身份": "Sales role",
  "采购产品／服务品类": "Products / services to purchase",
  "供应产品／服务品类": "Products / services supplied",
  "目标采购数量／规模（选填）": "Purchase volume / scale (optional)",
  "产能（选填）": "Production capacity (optional)",
  "采购地区／目标市场": "Procurement regions / target markets",
  "最小起订量 MOQ（选填）": "Minimum order quantity (optional)",
  "是否具备进口能力": "Import capability",
  "出口能力": "Export capability",
  "采购授权证明（选填）": "Procurement authorization reference (optional)",
  "交货周期（选填）": "Lead time (optional)",
  "特殊行业资质及许可证（依法需要时填写）": "Industry qualifications / permits (where required)",
  "增强信任资料（选填）": "Additional credentials (optional)",
  "替代核验资料": "Alternative verification",
  "不上传证照的原因": "Reason for not uploading a registration document",
  "补充企业登记情况或替代核验方式": "Registration details or alternative verification method",
  "可填写公开登记查询渠道或授权核验说明，请勿填写个人证件号。": "Provide a public registry reference or authorized verification method. Do not include personal ID numbers.",
  "业务核验资料编号（选填）": "Business evidence reference (optional)",
  "身份申请说明": "Application statement",
  "请确认企业业务授权": "Confirm your business authorization",
  "我确认已取得企业的采购业务授权，可提交资料供平台人工核验。": "I am authorized to submit procurement information for manual verification.",
  "我确认已取得企业的销售业务授权，可提交资料供平台人工核验。": "I am authorized to submit sales information for manual verification.",
  "买方与卖方分别审核；认证通过可发布对应供需，对接还需有效会员资格。": "Buyer and supplier certifications are reviewed separately. Certification enables publishing; connections also require active membership.",
  "创建与维护采购需求": "Publish and manage procurement requests",
  "创建与维护供应信息": "Publish and manage supply listings",
  "最近申请": "Latest application",
  "查看认证资料": "View certification profile",
  "企业资料已更新，请重新加载后再保存": "Company information has changed. Reload before saving.",
  "修改企业主体会重置双身份认证；修改业务资料仅重置当前身份，需重新提交审核。": "Changes to company registration reset both certifications. Business profile changes reset this role only. Submit again for review.",
  "认证业务资料已保存": "Certification profile saved",
  "营业执照或等效登记证明可选；未上传时需提供原因和替代核验资料。": "Registration documents are optional. Without one, provide a reason and alternative verification details.",
  "企业注册证明（选填）": "Company registration document (optional)",
  "保存认证资料": "Save certification profile",
  "企业业务授权": "Business authorization",
  "已确认": "Confirmed",
  "未确认": "Not confirmed",
  "业务认证资料": "Business certification profile",
  "请先保存完整的对应身份业务认证资料": "Save the complete business profile for this role first.",
  "未上传证照时，请填写原因和替代核验资料": "Provide a reason and alternative verification details when no document is uploaded.",
  "请填写身份申请说明": "Enter an application statement.",
  "请先补齐企业登记号和注册地址": "Complete the company registration number and registered address.",
  "申请缺少证照或替代核验资料，请退回后重新提交": "Registration evidence or alternative verification is missing. Return this application for resubmission.",
  "企业认证": "Company verification",
  "企业认证通过后，才可申请买方或卖方认证。": "Company verification must be approved before applying for buyer or supplier verification."
}
